import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GenericDialogComponent } from 'src/app/modules/shared/generic-dialog/generic-dialog.component';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { ProjectsService } from 'src/app/modules/shared/services/projects.service';
import { SidenavService } from 'src/app/modules/shared/services/sidenav.service';
import { ProjectDialogComponent } from '../project-dialog/project-dialog.component';
import { LanguageService } from 'src/app/modules/shared/services/language.service';
import { UsersManagementService } from 'src/app/modules/shared/services/usersManagement.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { getProjectErrorMessages } from 'src/app/constants/project-error-messages';

import { throwError } from 'rxjs';
import { retryWhen, catchError, scan, delay, filter, switchMap, take } from 'rxjs/operators';
import { ScrollControlService } from 'src/app/modules/shared/services/scroll-control.service';
import { AuthService } from 'src/app/modules/shared/services/auth.service';
import { Permission } from 'src/app/modules/shared/security/permission';
import { PermissionService } from 'src/app/modules/shared/services/permission.service';
import { TenantsService } from 'src/app/modules/shared/services/tenants.service';

@Component({
  standalone: false,
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {

  Permission = Permission
  variables: any;
  errorMessages: any;
  isOpen: boolean = false;
  projects: any[] = [];
  userName: any;
  userMail: any;
  shouldPinSidenav: boolean = false;
  colorWhite = "#fff";
  arrayProjs: any = [];
  arr1: any = [];
  sort: string = "az";
  filterText: string = '';
  displayFilterText: string = '';

  isLoading: boolean = true;

  errorDetected: boolean = false;
  errorText: string = '';

  constructor(
    private service: DataService,
    public authService: AuthService,
    private router: Router,
    private projectsService: ProjectsService,
    private sidenavService: SidenavService,
    public dialog: MatDialog,
    private languageService: LanguageService,
    private _snackBar: MatSnackBar,
    private UsersManagementService: UsersManagementService,
    private projectService: ProjectsService,
    public permissionService: PermissionService,
    private scrollService: ScrollControlService,
    private tenantsService: TenantsService
  ) { }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
      this.errorMessages = getProjectErrorMessages(vars);
    });

    this.scrollService.setScroll(true);

    this.service.setEstimate({});

    // Restore filter saved before navigating to project detail
    try {
      const saved = this.service.getProjectsFilter();
      if (saved) {
        this.displayFilterText = saved;
        this.filterText = saved.toLowerCase();
      }
    } catch { /* sessionStorage unavailable – proceed without filter */ }

    // Always fetch fresh data from the database
    this.getAllProjects();
  }

  getAllProjects() {
    this.isLoading = true;
    this.errorDetected = false;

    this.projectsService.getProjects().pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error; // Exceeded retry attempts, propagate error
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error fetching projects:', err);
        this.errorDetected = true;
        this.errorText = this.variables.detectedError;
        return throwError(() => err); // Forward the error for subscriber to handle
      })
    ).subscribe({
      next: (data: any[]) => {
        try {
          this.arrayProjs = data;
          if (!data || data.length === 0) {
            this.errorDetected = true;
            this.errorText = this.variables.noProjectFound;
          } else {
            this.projects = this.filterText
              ? data.filter((p: any) => p.name.toLowerCase().includes(this.filterText))
              : data;
          }
        } catch (err) {
          console.error('Error processing data:', err);
          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  onSidenavToggle() {
    this.isOpen = !this.isOpen;
    this.sidenavService.sideNavState$.next(this.isOpen);
  }

  onCheckboxChange(event: any) {
    this.shouldPinSidenav = event;
    this.sidenavService.shouldPinSidenavState.next(this.shouldPinSidenav);
  }

  goToProject(projectId: any) {
    try {
      if (this.filterText) {
        this.service.setProjectsFilter(this.displayFilterText);
      }
    } catch { /* sessionStorage unavailable – navigate anyway */ }
    this.service.setProject(projectId);
    this.router.navigate(['/projecto']);
  }

  clearProjectsFilterAndNavigate() {
    this.service.clearProjectsFilter();
    this.router.navigate(['/projectos']);
  }

  addProject() {
    this.tenantsService.loadCurrent().pipe(take(1)).subscribe(tenant => {
      const data = {
        message: this.variables.addNewProject,
        type: "ADD",
        maintenancePct: tenant?.maintenancePct ?? 0
      };
      let dialogRef = this.dialog.open(ProjectDialogComponent, { data: data });

      dialogRef.afterClosed().subscribe((data: any) => {
        if (data.data.success) {
          this.getAllProjects();


          this.authService.userDataLoaded$.pipe(
            filter(loaded => loaded),
            take(1),
            switchMap(() => this.authService.getUserData().pipe(take(1)))
          ).subscribe(result => {
            if (result) {
              this.getAllProjects();

              this.userName = result.name + " " + result.lastName

              this.userMail = result.email

              this.projectsService.addUserToProject(data.projId, this.userName, this.userMail).subscribe((query: any) => {
                if (query.success) {
                  console.log(query);
                }
                else {
                  console.log("MOSTRAR ERRO", query.error);
                }
              })

            }
            else {
              console.log("MOSTRAR ERRO", result.error);
            }
          })
        }
        else {
          console.log("MOSTRAR ERRO", data.error);
        }
      });
    });
  }

  editProject(project: any) {

    const data = {
      message: this.variables.changeProject,
      name: project.name,
      region: project.region,
      active: project.active,
      projectId: project.id,
      maintenancePct: project.maintenancePct,
      type: "EDIT",
    }

    let dialogRef = this.dialog.open(ProjectDialogComponent, { data: data });

    dialogRef.afterClosed().subscribe((data: any) => {
      if (data.data.success) {
        this.getAllProjects();
      } else {
        console.log("MOSTRAR ERRO", data.error);
      }
    });
  }

  deleteProject(project: any) {
    const dialogRef = this.dialog.open(GenericDialogComponent, {
      data: { message: this.variables.sureContinueMessage, isCompleteOrIncomplete: false }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.data === true) {
        this.projectsService.deleteProject(project.id).subscribe({
          next: () => {
            this.getAllProjects();
            this._snackBar.open(this.variables.projectDeletedSuccessfully, 'X', { panelClass: ['successful-snackbar'], duration: 4000 });
          },
          error: (error: any) => {
            const message = this.errorMessages[error.error?.message] || this.variables.detectedError;
            this._snackBar.open(message, 'X', { panelClass: ['error-snackbar'], duration: 4000 });
          }
        });
      }
    });
  }


  alphabeticalOrder() {
    switch (this.sort) {
      case ("az"): {
        this.projects.sort((item1: any, item2: any) => item1.name.localeCompare(item2.name));
        this.sort = "za";
        break;
      }
      case ("za"):
        this.projects.sort((item1: any, item2: any) => item2.name.localeCompare(item1.name));
        this.sort = "az"
        break;
    }
  }

  searchFilter(event: Event) {
    const rawValue = (event.target as HTMLInputElement).value.trim();
    const filterValue = rawValue.toLowerCase();
    this.displayFilterText = rawValue;
    this.filterText = filterValue;

    if (filterValue === '') {
      this.projects = [...this.arrayProjs];
      return;
    }

    this.projects = this.arrayProjs.filter((project: any) => {
      return project.name.toLowerCase().includes(filterValue);
    });
  }
}
